<template>
  <div class="google-login-container">
    <button 
      @click="handleGoogleLogin" 
      :disabled="loading" 
      class="google-login-button"
      :class="{ 'loading': loading }"
    >
      <img 
        v-if="!loading" 
        src="https://assets.staging.crowdblue.com/v2/demo/all/img/google-icon.svg" 
        alt="Google" 
        class="google-icon"
      />
      <div v-else class="loading-spinner"></div>
      <span class="button-text">
        {{ loading ? 'Loading...' : 'Sign up with Google' }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import { useUserStore } from '../../../store/useUserStore.js';
import auth from '../auth.js';

export default {
  name: 'GoogleSignUp',
  
  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async handleGoogleLogin() {
      this.loading = true;
      
      try {
        const callback = async data => {
          await this.checkUserLogin(this.$root._handleCheckResponse);
          await this.handleSocialNetworkSignUp(data.isSignup === '1');
          
          window.location.href = '/feed';
        };
        
        await auth.loginWithSocialMedia('google', callback);
      } catch (error) {
        console.error('Google login error:', error);
        this.$emit('login-error', error);
      } finally {
        this.loading = false;
      }
    },

    ...mapActions(useUserStore, ['checkUserLogin', 'handleSocialNetworkSignUp']),
  },
};
</script>

<style scoped>
.google-login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 300px;
}

.google-login-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 48px;
  background: var(--white);
  border: 1px solid var(--neutral-2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: var(--sans-font);
  font-size: 16px;
  font-weight: 500;
  color: var(--neutral-2);
  padding: 0 16px;
}

.google-login-button:hover:not(:disabled) {
  background: var(--white);
  border-color: var(--neutral-2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.google-login-button:active:not(:disabled) {
  transform: translateY(1px);
}

.google-login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.google-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.button-text {
  font-weight: 500;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid var(--neutral-1);
  border-top: 2px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading .button-text {
  opacity: 0.8;
}
</style>
